import axios from 'axios';
import { serverUrl } from 'src/config';
const instance = axios.create({
  baseURL: serverUrl,
});

instance.defaults.headers['Content-Type'] = 'application/json';
instance.defaults.headers['Access-Control-Allow-Origin'] = '*';

export { instance };
